import CreateTemplateModal from './CreateTemplateModal';

export default CreateTemplateModal;
